<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-form method="post" id="nativeForm" v-model="valid">
                        <v-card>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="12">
                                        <h3>
                                            Export Report(Health check &
                                            Timeline)
                                        </h3>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-menu
                                            v-model="modal"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="dateRangeText"
                                                    label="Date range"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="form_search.date"
                                                range
                                                @change="get_date()"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-progress-linear
                                            v-if="chk_export === true"
                                            indeterminate
                                            color="cyan"
                                        ></v-progress-linear>
                                        <v-btn
                                            v-if="chk_export === false"
                                            block
                                            color="green accent-3"
                                            class="mt-4"
                                            @click="export_data(1)"
                                            :disabled="!valid"
                                        >
                                            Export Data
                                        </v-btn>
                                        <v-btn
                                            block
                                            class="mt-3"
                                            @click="refresh_data(1)"
                                            >Refresh</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    computed: {
        dateRangeText() {
            this.form_search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.form_search.date.join(" ~ ")
        },
    },
    methods: {
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
            }
        },
        async export_data() {
            this.chk_export = true
            console.log(this.form_search)
            await axios({
                url: url + "covid/export-report",
                method: "POST",
                responseType: "blob",
                data: this.form_search,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                this.chk_export = false
            })
        },
        refresh_data() {
            this.form_search.date = []
        },
    },
    data() {
        return {
            chk_export: false,

            tk: null,

            modal: false,

            form_search: {
                date: [],
            },
            valid: false,
            dateR: [(v) => !!v || "Dates  is required"],
            team_name: localStorage.team_name,
            role_name: localStorage.role_name,
            tk_name: localStorage.fullname,
        }
    },
}
</script>
